import { api } from "..";

export async function addSuspendedMatch(
  matchId: number,
  providerId: number,
  feedType: string,
  userId?: number,
  password?: string
) {
  const res = await api.client.post("/matches/suspended", {
    matchId,
    userId,
    providerId,
    feedType,
    password,
  });
  return res.data;
}
